export const SEARCH_REQUEST_DELAY = 1000
export const TOOLTIP_VISIBLE_DELAY = 2000
export const HYBRID_SEARCH_MAX_LENGTH = 300
